module.exports = __webpack_public_path__ + "img/Trujillo.1e3fee5c.svg";